import { Frame, FrameTarget, FrameForm, FrameAnchor } from '@studiometa/ui';

/**
 * @typedef {{}} FrameTabsProps
 */

/**
 * FrameTabs component.
 * @augments {Base<FrameTabsProps>}
 */
export default class FrameTabs extends Frame {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'FrameTabs',
    components: {
      FrameForm,
      FrameTarget,
      FrameAnchor,
    },
    refs: ['loader'],
    options: {
      ...Frame.config.options,
    },
  };

  /**
   * Show loader and add style to cursor to give feedback
   */
  onBeforeFetch() {
    document.body.style.cursor = 'wait';
    this.$refs.loader.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   * Reinit cursor
   */
  onAfterEnter() {
    document.body.style.cursor = '';
  }
}
